import React from "react";

/**
 * Junago logo mark.
 * - `size` controls the square glyph.
 * - `wordmark` shows the "Junago." text after the mark.
 * - `tone` controls the background ("dark" for inverted contexts).
 */
export default function JunagoLogo({ size = 36, wordmark = true, tone = "dark", className = "" }) {
  const isDark = tone === "dark";
  const bg = isDark ? "#0F172A" : "#FFFFFF";
  const fg = isDark ? "#FFFFFF" : "#0F172A";

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span
        className="inline-flex items-center justify-center rounded-[10px] shrink-0"
        style={{ width: size, height: size, background: bg }}
        aria-hidden="true"
      >
        <svg viewBox="0 0 32 32" width={size * 0.62} height={size * 0.62} fill="none">
          {/* Stylised J with violet dot */}
          <path
            d="M20 5.5v13.5c0 4.142-3.358 7.5-7.5 7.5S5 23.142 5 19"
            stroke={fg}
            strokeWidth="3.2"
            strokeLinecap="round"
            fill="none"
          />
          <circle cx="24" cy="6.8" r="3" fill="#7C3AED" />
        </svg>
      </span>
      {wordmark && (
        <span className={`font-heading text-lg font-semibold tracking-tight ${isDark ? "text-slate-900" : "text-white"}`}>
          Junago<span className="text-violet-600">.</span>
        </span>
      )}
    </span>
  );
}
